import CRMIReportUploadModal from "./CRMIReportUploadModal";

export default CRMIReportUploadModal;
